/* Publish by EComposer at 2026-09-25 17:33:42*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-akxu89uxann"]=  window.__ectimmers["ecom-akxu89uxann"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-akxu89uxann').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-akxu89uxann', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lwnndh8idp9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwnndh8idp9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bkh5prckwaw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bkh5prckwaw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uv46igja98o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uv46igja98o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-omyuonazez').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-omyuonazez', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ieiaj9kz9jt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ieiaj9kz9jt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d3y1kik58e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d3y1kik58e', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-iz2ulozb5me"]=  window.__ectimmers["ecom-iz2ulozb5me"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-iz2ulozb5me').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iz2ulozb5me', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eci0xyguxw8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eci0xyguxw8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9as66e4uecn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9as66e4uecn', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mptjabb4qn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mptjabb4qn', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kkwjkt4j3w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kkwjkt4j3w', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g57ks40i76').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g57ks40i76', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b6ih1szuusn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b6ih1szuusn', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}